// Example of Conversion
// 1st hour to 2nd hour → from minute 1 to 120.
// 3rd hour to 4th hour → from minute 121 to 240.
import moment from 'moment'

// 5th hour to 6th hour → from minute 241 to 360.
export const convertHoursToBackendMinutes = (
  fromHour: number,
  toHour: number | null | undefined
) => {
  return {
    fromMinute: (fromHour - 1) * 60 + 1,
    toMinute: toHour ? toHour * 60 : undefined,
  }
}

// Example of Conversion
// From minute 1 to 120 → 1st hour to 2nd hour.
// From minute 121 to 240 → 3rd hour to 4th hour.
// From minute 241 to 360 → 5th hour to 6th hour.
export const convertBackendMinutesToHours = (
  fromMinute: number,
  toMinute: number | null | undefined
) => {
  return {
    fromHour: Math.ceil(fromMinute / 60),
    toHour: toMinute ? toMinute / 60 : undefined,
  }
}

export const convertBackendMinutesToHoursString = (min: number) => {
  const duration = moment.duration(min, 'minutes')
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()

  if (minutes === 0) {
    return `${hours}h`
  } else {
    return `${hours}h ${minutes}min`
  }
}
